module.exports = "pegasus/assets/hexline-pinterest.gif";